/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      // Accessibility: make the remove icon keyboard accessible
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.dispatchEvent(new CustomEvent('cart:remove', {
          bubbles: true,
          detail: { key: this.dataset.key, index: this.dataset.index }
        }));
       }, { signal: this.abortController.signal });

      // Accessibility: allow Enter and Space to remove an item
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.click();
        }
      }, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }
  customElements.define('cart-remove', CartRemove);
}